// frontend/src/slices/deliveryStaffSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    isAuthenticated: false, // Make sure this is false by default
    deliveryStaff: null,
    error: null
};

const deliveryStaffSlice = createSlice({
    name: 'deliveryStaff',
    initialState,
    reducers: {
        loginRequest(state) {
            state.loading = true;
            state.error = null;
        },
        loginSuccess(state, action) {
            state.loading = false;
            state.isAuthenticated = true;
            state.deliveryStaff = action.payload.deliveryStaff;
            state.error = null;
        },
        loginFail(state, action) {
            state.loading = false;
            state.isAuthenticated = false;
            state.deliveryStaff = null;
            state.error = action.payload;
        },
        logout(state) {
            state.loading = false;
            state.isAuthenticated = false;
            state.deliveryStaff = null;
            state.error = null;
        },
        clearError(state) {
            state.error = null;
        }
    }
});

export const {
    loginRequest,
    loginSuccess,
    loginFail,
    logout,
    clearError
} = deliveryStaffSlice.actions;

export default deliveryStaffSlice.reducer;